import dex from './dex'
import points from './points'
import rebate from './rebate'
export default {
  home: {
    app: 'Memeshot',
    title: "Memeshot.com , that's the meme.",
    subTitle: 'تابع الجديد في الميم كوينز ، خذ فرصتك. هذا كل شيء.',
    inviteFriends: ' انضم إلى مجتمع من المتخصصين وحقق مكاسب تصل إلى',
    inviteTextEnd: 'ضعف! ',
    appStore: 'أبل ستور',
    testFlight: 'TestFlight',
    googlePlay: 'جوجل بلاي',
    android: 'أندرويد',
    scanToDownload: 'إمسح للتحميل',
    soon: 'قريباً',
    downloadFrom: 'تحميل من',
    appDownload: 'تحميل تطبيق',
    joinUs: 'انضم إلينا',
    followUs: 'تابعنا',
    learn: 'استكشف',
  },
  referralCenter: {
    inviteFriend: 'ادعُ أصدقاءك واربح عمولة 30% من رسوم  تداولاتهم',
    referralRules: 'قواعد الإحالة',
    totalReward: 'إجمالي مكافآتي',
    usdtAmount: '$',
    referralCount: 'عدد الإحالات',
    defaultReferral: 'عوائدي',
    youReceive: 'نسبة عوائدي',
    receiveAmount: '50%',
    referralLink: 'رابط الإحالة',
    inviteButton: 'ادعُ الأصدقاء الآن!',
    referralOverview: 'مركز الإحالة',
    totalReferralIncome: 'إجمالي العوائد ($)',
    totalReferralCount: 'إجمالي الإحالات',
    myInvitations: 'دعواتي',
    myRebates: 'عوائدي',
    userId: 'معرّف المستخدم',
    rebateRate: 'نسبة العائد',
    registrationTime: 'وقت التسجيل',
    releaseTime: 'وقت الإصدار',
    rebateAmount: 'مبلغ العائد',
    status: 'الحالة',
    pendingRelease: 'قيد الانتظار',
    released: 'مكتمل',
    copied: 'تم النسخ',
    dataDetails: 'التفاصيل',
    joinBtn: 'شراكة استراتيجية',
    title1: 'دعوة عضو المجتمع (R)',
    desc1: 'يحصل عضو المجتمع على نسبة 10% من رسوم المستخدمين الذين دعاهم',
    title2: 'دعوة قائد مجتمع ذهبي (G)',
    desc2:
      'يحصل قائد مجتمع ذهبي (G) على نسبة 50% من رسوم المستخدمين الذين دعاهم',
    title3: 'دعوة قائد مجتمع فضي (S)',
    desc3:
      'يحصل قائد مجتمع فضي (G) على نسبة 40% من رسوم المستخدمين الذين دعاهم',
    invitation: 'ادعُ أصدقاءك',
    pageTitle: 'ادعُ أصدقاءك',
    pageSubtitle: 'تمتع بعمولة ** من رسوم التداول',
    invitationRelationship: 'المستوى',
    rebateRatio: 'نسبة العمولة',
    inviterID: 'الداعي',
    hash: 'التفاصيل',
    prePage: 'السابق',
    nextPage: 'التالي',
  },
  referralRulesTexts: {
    text0: 'أنواع الداعين:',
    text1: 'قائد مجتمع ذهبي (G)',
    text2: 'قائد مجتمع فضي (S)',
    text3: 'عضو المجتمع (R)',
    text4: 'قواعد الدعوات:',
    text5: 'قائد مجتمع ذهبي (G)',
    text6: 'يحصل على 40% من عمولات قائد مجتمع فضي (S) المدعو مباشرة.',
    text7: 'يحصل على 50% من عمولات عضو المجتمع (R) المدعو مباشرة.',
    text8: 'يحصل على 10% من عمولات عضو المجتمع (R) المدعو بشكل غير مباشر.',
    text9: 'قائد مجتمع فضي (S)',
    text10: 'يحصل على 40% من عمولات عضو المجتمع (R) المدعو مباشرة.',
    text11: 'عضو المجتمع (R)',
    text12: 'يحصل على 10% من عمولات عضو المجتمع (R) المدعو مباشرة.',
    text13: 'كيفية الحصول على الدور:',
    textRoleTitle1: 'قائد مجتمع ذهبي (G)',
    text14:
      "الوصول إلى إجمالي عمولات 50,000 دولار أو التقديم من صفحة الدعوات عبر 'الشراكة الاستراتيجية'.",
    textRoleTitle2: 'قائد مجتمع فضي (S)',
    text15:
      'الوصول إلى إجمالي عمولات 30,000 دولار أو التقديم للحصول على هذا الدور، أو التسجيل من خلال رابط الدعوة قائد مجتمع ذهبي (G).',
    textRole2Text: '',
    textRoleTitle3: 'عضو المجتمع (R)',
    text16:
      'إنشاء حساب مباشرة، أو الدعوة من قبل قائد مجتمع ذهبي (G) أو قائد مجتمع فضي (S) أو عضو المجتمع (R).',
    text17: 'دفع العوائد:',
    text18: 'تتم تسوية العوائد عندما يصل المبلغ الإجمالي إلى 5 دولارات.',
  },
  register: {
    title: 'إنشاء حساب Memeshot',
    account: 'حساب',
    email: 'البريد الإلكتروني',
    accountPlaceholder: 'إدخال البريد الإلكتروني',
    accountErrMsg: 'إدخال البريد الإلكتروني الصحيح',
    password: 'كلمة المرور',
    passwordPlaceholder: 'إدخال كلمة المرور',
    passwordErrMsg:
      'كلمة السر يجب أن تحتوي على ما لا يقل عن ثلاثة انواع: حروف صغيرة، كبيرة، ارقام، أو رموز .',
    signIn: 'تسجيل دخول',
    signUp: 'إنشاء حساب',
    verifyBtn: 'رمز التحقق',
    verify: 'رمز التحقق',
    verifyDesc: ' إدخال رمز التحقق - 6 أرقام.',
    emailVerify: 'رمز تحقق بريد إلكتروني',
    emailVerifyPlaceholder: 'إدخل رمز التحقق',
    resend: 'إعادة إرسال',
    confirm: 'تأكيد',
    confirmPassword: 'تأكيد كلمة المرور',
    confirmPasswordErr: 'كلمات المرور غير متناسقة',
    inviteCode: 'رمز الدعوة (أختياري)',
  },
  Cancellation: {
    logoffAccount: 'تقديم طلب حذف الحساب',
    reason: 'سبب',
    reasonCancellation: 'سبب حذف حسابك',
    applyInTitle: 'قيد المراجعة ، يرجى الانتظار',
    applyDoneText: 'تم حذف حسابك بنجاج',
    cancelApplyButton: 'إلغاء',
    submit: 'قدم',
    cancelApply: 'إلغاء الطلب',
  },

  // 目前只支持英文版
  userAgreement: {
    welcome: 'Thank you for using Memeshot!',
    policyMainText:
      'This Privacy Policy details how we collect, use, disclose, and protect your personal information to ensure your privacy rights. We are committed to complying with data privacy laws and regulations and safeguarding the security of your personal information.',
    part1: '1. Protection of Information',
    part1Text:
      'In the course of using this application, we may protect information including but not limited to the following types:',
    part1_1: '1.1 User Identity Information',
    part1_1Text:
      '- Wallet Address: The blockchain wallet address you create or connect to this application. We do not collect your real identity information.',
    part1_1Text2:
      '- Transaction Records: Necessary on-chain transaction records used to provide services, which do not include any unnecessary personal identification information.',
    part1_2: '1.2 Usage Information',
    part1_2Text:
      '- Application Usage Data: We automatically collect your interaction data with this application, such as page visits, clicks, and browsing behavior, to help us optimize application features and user experience.',
    part1_3: '1.3 Device Information',
    part1_3Text:
      "- Device Identifiers and Operating System: Includes the device's operating system version and unique device identifier, used to ensure the normal operation and security of the application.",
    part2: '2. Use of Information',
    part2Text:
      'We strictly use your information in a legal, proper, and necessary manner in accordance with this Privacy Policy and relevant laws and regulations. The specific purposes are as follows:',
    part2_1:
      '- Providing and Maintaining Services: Processing on-chain transactions to ensure the normal operation of the custodial wallet.',
    part2_2:
      '- Improving User Experience: Continuously optimizing product features and user interfaces by analyzing application usage behaviors.',
    part2_3:
      '- Ensuring Security: Detecting, preventing, and resolving fraud and illegal activities to protect the security of your assets.',
    part3: '3. Sharing of Information',
    part3Text:
      'We do not sell, rent, or share your personal information with any third parties, but we may share your information under the following circumstances:',
    part3_1:
      'Third-Party Service Providers: To provide application functionalities, we may need to share necessary information with trusted third-party partners. These third parties are limited to using your information only within the scope required to provide their services.',
    part3_2:
      'Legal Requirements: Your information may need to be disclosed if required by laws, legal processes, or government requests.',
    part4: '4. Security of Information',
    part4Text:
      'We are committed to protecting the security of your personal information and have implemented reasonable technical and managerial measures to prevent unauthorized access, disclosure, alteration, or destruction of your information. However, the network environment is not 100% secure, so please properly safeguard your wallet keys and other sensitive information.',
    part5: '5. Privacy Protection for Minors',
    part5Text:
      'This application is not intended for minors. If we discover that we have collected personal information from minors, we will take steps to delete the relevant data as soon as possible.',
    part6: '6. Your Rights',
    part6Text:
      'Under applicable data protection laws, you have the right to perform the following actions regarding your information:',
    part6_1:
      'Access, Update, and Deletion: You can access, update, or delete your account information.',
    part6_2:
      'Privacy Settings: You can adjust your privacy settings within the application at any time to manage how your information is collected and used.',
    part7: '7. Changes to the Privacy Policy',
    part7Text:
      'We may update this Privacy Policy from time to time. The updated Privacy Policy will be posted on this page with the effective date indicated. We recommend that you regularly review the Privacy Policy to stay informed about our latest privacy protection measures.',
  },
  dex: dex.ar_SA,
  points: points.ar_SA,
  rebate: rebate.ar_SA
}
